import { CourierUser } from '@shared/sdk-v1/models';

const DEFAULT_PADDING = 4;

/**
 * Format a raw mailbox number as `${prefix}${paddedNumber}` with NO separator,
 * e.g. `KJC00001`. Unlike the display formatter elsewhere, this returns an empty
 * string (not a "No Mailbox" sentinel) when there is no number, so it is safe to
 * push into analytics payloads.
 */
export const formatMailboxNumber = (
  rawMailboxNumber: number | string | undefined | null,
  prefix: string | undefined,
  paddingLength: number | undefined
): string => {
  if (
    rawMailboxNumber === undefined ||
    rawMailboxNumber === null ||
    rawMailboxNumber === ''
  ) {
    return '';
  }

  const paddedNumber = String(rawMailboxNumber).padStart(
    paddingLength || DEFAULT_PADDING,
    '0'
  );
  return prefix ? `${prefix}${paddedNumber}` : paddedNumber;
};

/**
 * Derive the full mailbox number (e.g. `KJC00001`) for a user from their first
 * mailbox. Returns an empty string when the user has no mailbox yet.
 */
export const deriveMailboxNumber = (
  user: CourierUser | undefined,
  prefix: string | undefined,
  paddingLength: number | undefined
): string =>
  formatMailboxNumber(user?.mailboxes?.[0]?.mailboxNumber, prefix, paddingLength);
